import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Card } from '@/ui/primitives.js';
import { PageHeader } from '@/ui/Layout.js';
import { GUIDE_ROWS, guideSummary } from './guideContent.js';
import { SetupIllustration } from './SetupIllustration.js';
import { cameraDistance } from '@/lib/units.js';
import { SourcesList } from '@/features/sources/SourcesList.js';

const BADGE: Record<string, { label: string; color: string }> = {
  yes: { label: 'Checked automatically', color: 'var(--color-state-good)' },
  partial: { label: 'Partly checked', color: 'var(--color-state-fhp)' },
  no: { label: 'Up to you', color: 'var(--color-muted)' },
};

export function GuidePage(): ReactNode {
  return (
    <div className="space-y-4">
      <PageHeader
        title="Camera guide"
        subtitle="Nine things that decide whether a session is measurable."
        action={
          <Link to="/capture" className="text-sm font-semibold underline">
            Back
          </Link>
        }
      />
      <Card>
        <SetupIllustration />
      </Card>
      {GUIDE_ROWS.map((row) => (
        <Card key={row.id} className="space-y-1.5">
          <div className="flex items-start justify-between gap-3">
            <h2 className="font-semibold">{row.title}</h2>
            <span
              className="shrink-0 text-[11px] font-semibold"
              style={{ color: BADGE[row.autoChecked]!.color }}
            >
              {BADGE[row.autoChecked]!.label}
            </span>
          </div>
          <p className="text-sm text-ink-soft">{guideSummary(row, cameraDistance())}</p>
          <p className="text-xs text-muted">{row.detail}</p>
        </Card>
      ))}
      <div className="space-y-1 pt-2">
        <h2 className="text-lg font-semibold">Where the numbers come from</h2>
        <p className="text-sm text-muted">
          The published work behind what the app measures. Estimates for posture habits, not a
          medical measurement.
        </p>
      </div>
      <SourcesList />
    </div>
  );
}
